import React from 'react';
import { Shield, FileCheck, Users } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-slate-900 text-white" data-id="element-78">
      <div className="container mx-auto px-4" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <div className="text-center mb-16" data-id="element-81">
            <span className="text-amber-400 font-bold tracking-wider uppercase text-sm" data-id="element-82">
              La Solución Definitiva
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-6" data-id="element-83">
              El Protocolo Sombrilla
            </h2>
            <p className="text-xl text-slate-300" data-id="element-84">
              La triple capa de protección que el sistema de EE. UU. no quiere
              que sepas que puedes activar sin un abogado de $300/hora.
            </p>
          </div>

          <div className="grid gap-12" data-id="element-85">
            {/* Layer 1 */}
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-86">
              <div className="w-full md:w-1/3 flex justify-center" data-id="element-87">
                <div className="w-32 h-32 bg-amber-500/10 rounded-full flex items-center justify-center border-2 border-amber-500/50 shadow-[0_0_30px_rgba(245,158,11,0.3)]" data-id="element-88">
                  <Users className="w-16 h-16 text-amber-400" data-id="element-89" />
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-90">
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-91">
                  Capa 1: El Escudo de Custodia
                </h3>
                <p className="text-slate-300 text-lg" data-id="element-92">
                  Documentos legales específicos que designan quién cuidará de
                  tus hijos inmediatamente. Esto bloquea la intervención de CPS
                  (Servicios de Protección Infantil) y mantiene a tus hijos con
                  la familia que tú elijas, no con extraños.
                </p>
              </div>
            </div>

            {/* Layer 2 */}
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-93">
              <div className="w-full md:w-1/3 flex justify-center md:order-2" data-id="element-94">
                <div className="w-32 h-32 bg-blue-500/10 rounded-full flex items-center justify-center border-2 border-blue-500/50 shadow-[0_0_30px_rgba(59,130,246,0.3)]" data-id="element-95">
                  <FileCheck className="w-16 h-16 text-blue-400" data-id="element-96" />
                </div>
              </div>
              <div className="w-full md:w-2/3 md:order-1" data-id="element-97">
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-98">
                  Capa 2: El Poder Financiero
                </h3>
                <p className="text-slate-300 text-lg" data-id="element-99">
                  Autorización legal para que una persona de confianza maneje
                  tus finanzas, pague tu renta, venda tu auto o envíe tus
                  ahorros a tu país de origen si tú no puedes hacerlo. Protege
                  el patrimonio de toda tu vida.
                </p>
              </div>
            </div>

            {/* Layer 3 */}
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-100">
              <div className="w-full md:w-1/3 flex justify-center" data-id="element-101">
                <div className="w-32 h-32 bg-red-500/10 rounded-full flex items-center justify-center border-2 border-red-500/50 shadow-[0_0_30px_rgba(239,68,68,0.3)]" data-id="element-102">
                  <Shield className="w-16 h-16 text-red-400" data-id="element-103" />
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-104">
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-105">
                  Capa 3: La Carpeta Roja
                </h3>
                <p className="text-slate-300 text-lg" data-id="element-106">
                  El sistema físico de organización que convierte tu ITIN y
                  pasaporte en un muro de protección. Instrucciones paso a paso
                  para que tu familia sepa exactamente qué hacer en los primeros
                  72 minutos de una emergencia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}